// Components used in Markdown-compiled pages (cannot use <script setup> imports)
import NIcon from '/app/components/NIcon.vue';
import NAlert from '/app/components/NAlert.vue';
import NBrainLevelDemo from '/app/components/demo/BrainLevelDemo.vue';
import NNeuronsEarnedDemo from '/app/components/demo/NeuronsEarnedDemo.vue';
import { defineAppPlugin } from '/app/utils/app'


import '@bignerve/ui-icons';

export default defineAppPlugin(({ app }) => {
    // Register only components needed by Markdown-compiled templates
    app.component('NIcon', NIcon);
    app.component('NAlert', NAlert);
    app.component('NBrainLevelDemo', NBrainLevelDemo);
    app.component('NNeuronsEarnedDemo', NNeuronsEarnedDemo);
})
